import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {PeriodTypeSearch} from "./PeriodTypeSearch";


var vUI_Period_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_PERIOD_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Period Id',
            columnResourceName: 'colWBPeriodId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PERIOD_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Period Id', columnResourceName: 'colPeriodId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    PERIOD_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Period Name', columnResourceName: 'colPeriodName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    PERIOD_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Period Start Date',
            columnResourceName: 'colPeriodStartDate',
            alignment: HorizAlignment.Center
        },
        domainOptions: {maxLength: 50}
    },
    PERIOD_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Period End Date',
            columnResourceName: 'colPeriodEndDate',
            alignment: HorizAlignment.Center
        },
        domainOptions: {maxLength: 50}
    },
    WB_PERIODM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Period M Id',
            columnResourceName: 'colWBPeriodMId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {search: PeriodTypeSearch, profileId: "default", searchCondition: {}}
    },
    PERIOD_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Period Type Name',
            columnResourceName: 'colPeriodTypeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    PERIOD_TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Period Type ID',
            columnResourceName: 'colPeriodTypeID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB MDSET Id',
            columnResourceName: 'colWbMdSetId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var PeriodSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_PERIOD_ID',
        id_ui: 'PERIOD_ID',
        name: 'PERIOD_NAME'
    },


    searchProviderFields: vUI_Period_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Period_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}


var PeriodSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "PeriodSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'PERIOD_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PERIOD_NAME', renderOptions: {}},
        {profileFilterName: 'Period Type', searchProviderFieldId: 'WB_PERIODM_ID', renderOptions: {}}
    ],  // ISearchFields
    profileDisplayFields: [
        'PERIOD_ID', 'PERIOD_NAME', 'PERIOD_START_DT', 'PERIOD_END_DT', 'PERIOD_TYPE_ID', 'PERIOD_TYPE_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PeriodSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var PeriodSearchProfileBySource: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Period Date",
    renderOptions: {ui5ResourceId: "PeriodSearchProfileByPeriodType"},

    profileFilter: [
        {profileFilterName: 'StartDate', searchProviderFieldId: 'PERIOD_START_DT', renderOptions: {}},
        {profileFilterName: 'EndDate', searchProviderFieldId: 'PERIOD_END_DT', renderOptions: {}}
    ],  // ISearchFields
    profileDisplayFields: [
        'PERIOD_ID', 'PERIOD_NAME', 'PERIOD_START_DT', 'PERIOD_END_DT', 'PERIOD_TYPE_ID', 'PERIOD_TYPE_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PeriodSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var PeriodSearch: ISearch = {
    searchName: "Find Period",
    renderOptions: {ui5ResourceId: "PeriodSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PeriodSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("PeriodBO", "Period", PeriodSearch, "Period Search")

export {PeriodSearch}